import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cc from 'classcat';
import { isMobile } from 'utils/is-mobile';
import { GlobalIcon } from 'components/GlobalIcon';
import { Portal } from 'components/Shared/Portal';

type TProps = {
  count: number;
};

export const LoadingInProcess = ({ count }: TProps): ReactElement => {
  const { t } = useTranslation();

  const loadingPopup = useMemo(() => {
    return (
      <div
        className={cc([
          'loading__popup',
          {
            'loading__popup-mobile': isMobile()
          }
        ])}
      >
        <div className="loading__icon-container">
          <GlobalIcon
            lib="generic"
            name="time"
            theme="default"
            size={20}
            color="var(--v3-primary-6)"
          />
          <span>
            {t('betslip.betInProcess')} ({count})
          </span>
        </div>
        <div className="betslip__few-seconds">
          {t('betslip.aFewSecondsLeft')}
        </div>
      </div>
    );
  }, [count]);

  return isMobile() ? <Portal>{loadingPopup}</Portal> : loadingPopup;
};
